import React from 'react';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl-redux';
import config from '../../config';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { OrcProvider } from '@ontruck/orc';
import { ToastContainer } from '@ontruck/orc';
import { themeBaseOverwrite, themeComponentBaseOverwrite } from 'utils/style';

import { POIVenueDetailContextProvider } from 'modules/point-of-interest/venue-detail-modal';

import { ReactComponent as OrcIcons } from '@ontruck/orc/lib/orc.svg';
import MercuryGlobalStyles from 'styles';

const Root = ({ children, store }) => {
  return (
    <Provider store={store}>
      <IntlProvider>
        <OrcProvider
          themeBase={themeBaseOverwrite}
          themeComponentBase={themeComponentBaseOverwrite}
        >
          <GoogleOAuthProvider clientId={config.GOOGLE_APPS_CLIENTID}>
            <>
              <OrcIcons />
              <MercuryGlobalStyles textBase="1.2rem" />
              <POIVenueDetailContextProvider>{children}</POIVenueDetailContextProvider>
              <ToastContainer size="narrow" />
            </>
          </GoogleOAuthProvider>
        </OrcProvider>
      </IntlProvider>
    </Provider>
  );
};

export default Root;
